<template>
    <v-dialog v-model="isOpenLegendDialog" width="500">
        <v-card>
            <v-card-title>
                <div
                    v-if="$vuetify.breakpoint.xs"
                    class="primary--text text-overline"
                >
                    Leyenda de parámetros
                </div>
                <div
                    v-else
                    class="font-weight-light primary--text text-h4 ml-2"
                >
                    Leyenda de parámetros
                </div>
            </v-card-title>
            <v-divider class="test"></v-divider>
            <v-card-text class="px-2">
                <v-list dense>
                    <v-list-item color="primary" class="d-block pa-0">
                        <v-list-item v-for="(item, i) in items" :key="i">
                            <v-list-item-icon>
                                <v-icon
                                    v-text="item.icon"
                                    :color="item.color ? item.color : ''"
                                ></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title
                                    class="overline"
                                    v-text="item.title"
                                ></v-list-item-title>
                                <v-list-item-title
                                    class="font-weight-thin mt-n1 text-wrap"
                                    v-text="item.text"
                                ></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="isOpenLegendDialog = false">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'Legend',
    props: {
        items: {
            type: Array,
        },
    },
    data: () => ({}),
    computed: {
        isOpenLegendDialog: {
            get() {
                return this.$store.state.util.isOpenLegendDialog;
            },
            set(val) {
                this.$store.commit('util/isOpenLegendDialog', val);
            },
        },
    },
};
</script>
    